import React from 'react'
import { SUPPORT_EMAIL, PRIVACY_URL, TOS_URL, MAGAZINE_URL, HELP_URL, MISSION_URL, INSTALL_PAGE_URL, GEMSBY_URL } from '../../constants'

import styles from './Footer.module.css'
import abcImage from '../../../assets/images/webfoot-abc.png'
import cbsImage from '../../../assets/images/webfoot-cbs.png'
import foxImage from '../../../assets/images/webfoot-fox.png'
import nbcImage from '../../../assets/images/webfoot-nbc.png'
import classNames from 'classnames'

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.seenOn}>
        <h3>AS SEEN ON</h3>
        <img src={abcImage} />
        <img src={cbsImage} />
        <img src={foxImage} />
        <img src={nbcImage} />
      </div>
      <div>
        ©{new Date().getFullYear()} C.G. Diam Corp. &nbsp;All Rights Reserved.
      </div>
      <div>
        <ul className="list-unstyled list-inline">
          <li>
            <LinkWrapper to={GEMSBY_URL}>
              Gemsby
            </LinkWrapper>
          </li>
          <li>·</li>
          {/* <li>
            <LinkWrapper to={MISSION_URL}>
              Mission
            </LinkWrapper>
          </li>
          <li>·</li> */}
          {/* <li>
            <LinkWrapper to={INSTALL_PAGE_URL}>
              Download
            </LinkWrapper>
          </li>
          <li>·</li> */}
          <li>
            <LinkWrapper to={PRIVACY_URL}>
              Privacy
            </LinkWrapper>
          </li>
          <li>·</li>
          <li>
            <LinkWrapper to={TOS_URL}>
              Terms
            </LinkWrapper>
          </li>
          <li>·</li>
          <li>
            <LinkWrapper to={MAGAZINE_URL}>
              Magazine
            </LinkWrapper>
          </li>
          {/* <li>·</li> */}
          {/* <li>
            <LinkWrapper to={HELP_URL}>
              Help
            </LinkWrapper>
          </li>
          <li>·</li> */}
          {/* <li>
            <a href={`mailto:${SUPPORT_EMAIL}`}>Contact Us</a>
          </li> */}
        </ul>
      </div>
    </footer>
  )
}

export default Footer

const LinkWrapper = ({ to = '', children, className = '' }) => {
  const isValid = to && to.trim() !== '';

  if (!isValid) {
    return (
      <span className={styles.disabledWrapper}>
        <a
          className={classNames(className, styles.disabledLink)}
          href="#"
          onClick={e => e.preventDefault()}
        >
          {children}
        </a>
        <span className={styles.tooltip}>Link coming soon</span>
      </span>
    );
  }

  return (
    <a
      className={classNames(className)}
      href={to}
      target="_blank"
      rel="noreferrer"
    >
      {children}
    </a>
  );
};